import { AppState } from '../../../store';

export const createNewOrganizationModeSelector = (state: AppState) => state.organization.createNew;
